import React, { PureComponent } from 'react';
import './ModalConfirmation.style.less';
import { Row, Modal, Button } from 'antd';
import config from './ModalConfirmation.config';
class ModalConfirmation extends PureComponent {
  _renderTitle = value => (
    <Row className="modal-title-form-builder">{value}</Row>
  );
  _renderButton = (confirmType, onCancel, cancelText, onProceed, okText) => {
    switch (confirmType) {
      case 'success':
        return (
          <center className="btn-group-change">
            <Button className="btn-change" type="primary" onClick={onProceed}>
              {okText}
            </Button>
          </center>
        );
      case 'failed':
        return (
          <center className="btn-group-change">
            <Button className="btn-cancel" onClick={onCancel}>
              {cancelText}
            </Button>
          </center>
        );
      default:
        return (
          <center className="btn-group-change">
            <Button className="btn-cancel" onClick={onCancel}>
              {cancelText}
            </Button>
            <Button className="btn-change" type="primary" onClick={onProceed}>
              {okText}
            </Button>
          </center>
        );
    }
  };
  render() {
    // Destruct Props
    const {
      title,
      visible,
      content,
      cancelText,
      okText,
      onCancel,
      onProceed,
      confirmType,
    } = this.props;

    return (
      <Modal
        title={this._renderTitle(title)}
        visible={visible}
        footer={null}
        closable={false}
        className="modal-confirmation"
      >
        <center>{content}</center>

        {this._renderButton(
          confirmType,
          onCancel,
          cancelText,
          onProceed,
          okText,
        )}
      </Modal>
    );
  }
}

ModalConfirmation.propTypes = config.propTypes;
ModalConfirmation.defaultProps = config.defaultProps;

export default ModalConfirmation;
